"use client"

import ImageIcon from "@mui/icons-material/Image"
import { Box } from "@mui/material"
import Image from "next/image"
import { useState } from "react"
interface Props {
    alt: string
    src: string
    priority: boolean
}

export const LibraryItemCardImage = ({ alt, src, priority }: Props) => {
    const [failedToLoad, setFailedToLoad] = useState(false)

    if (failedToLoad)
        return (
            <Box sx={styles.image}>
                <ImageIcon sx={styles.icon} fontSize="large" />
            </Box>
        )

    return (
        <Image
            alt={alt}
            src={src}
            fill
            style={{ objectFit: "cover", borderRadius: 10 }}
            priority={priority}
            sizes="(min-width: 808px) 20vw, 70vw"
            onError={() => {
                setFailedToLoad(true)
            }}
        />
    )
}

const styles = {
    image: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "action.hover",
        width: "100%",
        height: "100%",
    },
    icon: {
        color: "action.selected",
    },
}
